function email(ev) {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    ev.target.value
  )
    ? false
    : true;
}
function regularExpression(ev, expr) {
  let answer = expr.value.test(ev.target.value) ? false : true;
  return answer;
}
let validateFunctions;
validateFunctions = {
  email,
  regularExpression
};
export { validateFunctions };
